import type { FC } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import UnderlinedTabs from '@wix/da-ds/pkg/Tabs/dsPresets/UnderlinedTabs';
import type { TabItem } from '@wix/da-ds/pkg/Tabs';
import { getStudioParams } from '../../../selectors/studio';

import s from './TierTabs.scss';

interface Props {}

const TierTabs: FC<Props> = () => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { tierId, contentType } = useSelector(getStudioParams);

  if (!(tierId && contentType)) {
    return null;
  }

  return (
    <UnderlinedTabs
      className={s['root']}
      uniformTabWidth={isMobile}
      items={
        [
          {
            label: t('studio.header.tabs.tier.subtabs.deviations'),
            index: 'deviations',
            href: Url.studioTier(parseInt(tierId), 'deviations'),
          },
          {
            label: t('studio.header.tabs.tier.subtabs.posts'),
            index: 'posts',
            href: Url.studioTier(parseInt(tierId), 'posts'),
          },
        ] as TabItem[]
      }
      activeIndex={contentType}
    />
  );
};

TierTabs.displayName = 'TierTabs';

export default TierTabs;
